const REGULAR_EXPRESSION = {};
REGULAR_EXPRESSION.MOBILE_PHONE = new RegExp(/^(375)(29|25|44|33)(\d{3})(\d{2})(\d{2})$/);
// E.164: код страны 1–9, всего 8–15 цифр (номер любой страны, без +)
REGULAR_EXPRESSION.MOBILE_PHONE_INTERNATIONAL = new RegExp(/^[1-9]\d{7,14}$/);
REGULAR_EXPRESSION.EMAIL = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export default REGULAR_EXPRESSION;
